import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const Enfermaria = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const condicional = useSelector((state) => state.addForm.modulos)
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>

                    <HeaderVerde texto="ENFERMARIA" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Enfermaria" nome="nomedaenfermaria" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="60vw" widthMobile="80vw" marginR="3vw" />
                        <Input label="Número de Leitos" nome="enfermarialeitos" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="10vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Nº de Pacientes Durante a Fiscalização" nome="enfermariapacientesfiscalizacao" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Input label="Nº de Pacientes Assistidos Pela Fisioterapia" nome="enfermariapacientesassistidos" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                    </div>


                    <HeaderVerde texto="FISIOTERAPEUTA NO SETOR DURANTE A INSPEÇÃO" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Quantos Fisioterapeutas no Setor" nome="enffisioescala" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        {RenderQtdFisio()}
                    </div>


                    <HeaderVerde texto="PROFISSIONAIS NA ESCALAS" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Total de Profissionais na Escala" nome="enfqtdescala" modulo={modulo} index={n}
                            widthWeb="5vw" widthMobile="80vw" marginR="3vw" tipo="number" />
                        <Select label="Assistência Fisioterapêutica 7 dias/Semanas" nome="enfassistencia7" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["sim", "não"]} />
                        <Select label="Jornada de Assistência da Fisioterapia" nome="enfabls" modulo={modulo} index={n}
                            widthWeb="20vw" widthMobile="80vw" marginR="3vw"
                            array={["menos de 6h/dia","6h/dia","12h/dia","18h/dia", "24h/dia"]} />
                    </div>

                    <HeaderVerde texto="LEGALIDADE" />
                    <div style={{ textAlign: "left" }}>
                        <Select label="CONFORMIDADE COM A RESOLUÇÃO COFFITO Nº  444/2014" nome="resolucao444" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="25vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                    </div>
                </Caixa >
            )

            function RenderQtdFisio() {
                let campos = []
                if (condicional[modulo].length > 0) var array = condicional
                else var array = ficha
                var quantidade = array[modulo][n]["enffisioescala"]
                if (array[modulo][n]["enffisioescala"]) {
                    for (let i = 0; i < quantidade; i++) {
                        campos.push(
                            <div>
                                <Input label="Profissional" nome="enfnomedoprofissional"
                                    modulo={modulo} index={n} subModulo="enfnomedoprofissional" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="30vw" widthMobile="80vw" marginR="3vw" />
                                <Select label="Jornada de Trabalho" nome="enfjornada"
                                    modulo={modulo} index={n} subModulo="enfjornada" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="14vw" widthMobile="80vw" marginR="3vw"
                                    array={["Diarista", "Plantonista", "Ambos"]} />
                                <Select label="Horário de Trabalho" nome="enfhrtrabalho"
                                    modulo={modulo} index={n} subModulo="enfhrtrabalho" indexSub={i}
                                    componentDisplay="inline-grid" widthWeb="14vw" widthMobile="80vw" marginR="3vw"
                                    array={["12h diurno", "12h noturno", "6h matutino", "6h vespertino", "6h noturno", "24 horas"]} />
                            </div>
                        )
                    }
                }
                return campos
            }
        }
        return partes
    }
}

export default Enfermaria